<template>
  <q-dialog v-model="visible" full-height position="right">
    <q-card class="full-card">
      <q-toolbar class="auto-height horizontal-line">
        <q-toolbar-title class="q-pa-sm"> テンプレート追加 </q-toolbar-title>
        <q-btn flat round dense icon="close" @click="onCancel" />
      </q-toolbar>
      <q-card-section>
        <div class="max-height-dialog">
          <q-form ref="formRef" greedy>
            <CLoading :loading="loading" />
            <div class="row q-ma-sm justify-between">
              <div class="text-h6">フレックスメッセージ</div>
              <q-btn dense unelevated class="btn-save" label="テンプレート編集" size="xs" @click="editTemplate" />
            </div>
            <div class="q-ma-sm flex-message-content">
              <img
                v-if="form._id && form.img && !isTemplateChanged"
                :src="form.img"
                alt="Message image"
                style="height: 200px"
              />
              <img v-else-if="messageImgUrl" :src="messageImgUrl" alt="Message image" style="height: 200px" />
            </div>
            <div class="row q-my-sm" v-if="form._id">
              <div class="q-mx-md text-grey-9 col-2 flex items-center justify-end">
                <span>{{ $t('label.display_id') }}</span>
              </div>
              <TagInputContent :tagValue="form._id" v-if="form._id !== ''" class="col q-mr-md"></TagInputContent>
            </div>
            <div class="row q-mt-sm">
              <div class="q-mx-md text-grey-9 col-2 flex items-center justify-end">
                <span>{{ $t('label.flex_message_template.template_name') }}</span>
              </div>
              <q-input
                lazy-rules
                :rules="[(val) => (val && val.length > 0) || requiredRule.templateName]"
                outlined
                v-model="form.name"
                dense
                :placeholder="$t('label.flex_message_template.template_name')"
                class="col q-mr-sm"
                ref="refName"
              />
            </div>
            <div class="row q-mx-sm q-my-md"><div class="full-width horizontal-line"></div></div>
            <div class="column q-pb-sm horizontal-line">
              <div class="q-ml-md q-mb-md text-grey-9">
                <span>説明</span>
              </div>
              <InputEmojiSelector v-model="form.description" type="textarea" placeholder="テキスト" class="q-mx-sm" />
            </div>
            <div class="text-h6 q-my-sm q-ml-sm">テンプレート内容</div>
            <div class="text-subtitle2 q-my-sm q-ml-sm">設定したテンプレート内容に沿って、自動で反映されます。</div>
            <div class="row q-mt-md q-mx-sm">
              <div class="q-mx-md text-grey-9 col-2 flex items-center justify-end">
                <span>{{ $t('label.flex_message_template.template_type') }}</span>
              </div>
              <q-chip class="btn-cancel col" size="16px">
                {{ $t('label.flex_message_template.' + templateType) }}
              </q-chip>
            </div>
            <div class="row q-mx-sm q-my-sm"><div class="full-width horizontal-line-dashed"></div></div>
            <div class="row q-ma-sm">
              <div class="q-mx-md text-grey-9 col-2 flex items-center justify-end">
                <span>動画</span>
              </div>
              <q-chip class="col" :class="presenceVideo ? 'btn-save' : 'btn-save-grey'" size="16px">
                {{ presenceVideo ? $t('label.flex_message_template.yes') : $t('label.flex_message_template.no') }}
              </q-chip>
            </div>
            <div class="row q-ma-sm">
              <div class="q-mx-md text-grey-9 col-2 flex items-center justify-end">
                <span>画像</span>
              </div>
              <q-chip class="col" :class="presenceImage ? 'btn-save' : 'btn-save-grey'" size="16px">
                {{ presenceImage ? $t('label.flex_message_template.yes') : $t('label.flex_message_template.no') }}
              </q-chip>
            </div>
            <div class="row q-ma-sm">
              <div class="q-mx-md text-grey-9 col-2 flex items-center justify-end">
                <span>ボタン</span>
              </div>
              <q-chip class="col" :class="presenceButton ? 'btn-save' : 'btn-save-grey'" size="16px">
                {{ presenceButton ? $t('label.flex_message_template.yes') : $t('label.flex_message_template.no') }}
              </q-chip>
            </div>
          </q-form>
        </div>
        <div class="row no-wrap items-center q-mt-md q-pr-md">
          <q-space />
          <div class="q-gutter-sm">
            <q-btn no-caps flat class="btn-cancel" @click="onCancel">{{ $t('cancel') }} </q-btn>
            <q-btn no-caps class="btn-save" @click="onSubmit"> {{ $t('save') }} </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
  <FlexMessageTemplateEditModal
    v-if="templateModalVisible"
    :modalVisible="templateModalVisible"
    :altText="currentAltText"
    :template="template"
    :appId="appId"
    :isAdmin="isAdmin"
    :isSuper="isSuper"
    @update:closeModal="onCloseModal"
    @update:template="(val) => (form = val)"
    @captureMessage="onCaptureMessage"
  />
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import { maska } from 'maska'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import CLoading from '@/components/common/ui/CLoading.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageTemplate } from '@/utils/types'
import cloneDeep from 'lodash/cloneDeep'
import InputEmojiSelector from '@/components/common/ui/InputEmojiSelector.vue'
import UploadApi from '@/api/upload'
import { ACTION_FLEX_MESSAGE_TEMPLATE } from '@/store/actions'
import TagInputContent from '@/components/common/ui/TagInputContent.vue'
import FlexMessageTemplateEditModal from '@/components/story/common/flex-message/FlexMessageTemplateEditModal.vue'

@Options({
  components: { FlexMessageTemplateEditModal, TagInputContent, InputEmojiSelector, CLoading },
  directives: { maska },
  emits: ['update:closeModal', 'updateTemplates'],
})
export default class FlexMessageTemplateFormModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  template!: IFlexMessageTemplate

  @Prop()
  previewImageUrl!: string

  @Prop()
  imgFile!: File

  @Prop()
  appId!: string

  @Prop()
  isMessageChanged!: boolean

  @Prop()
  isAdmin!: boolean

  @Prop()
  isSuper!: boolean

  @Prop()
  type!: string

  @Prop()
  altText!: string

  loading = false
  templateModalVisible = false
  isTemplateChanged = false
  messageImg: File | null = null
  messageImgUrl: string | null = null
  currentAltText = ''
  form: IFlexMessageTemplate = {
    _id: '',
    app_id: this.appId,
    name: '',
    img: '',
    description: '',
    type: 'bubble',
    is_video: false,
    is_image: true,
    is_button: false,
    contents: {},
    alt_text: '',
  }

  get templateType() {
    if (this.form.contents) {
      return this.form.contents.type
    }
    return this.form.type
  }

  get presenceVideo() {
    if (this.form.contents) {
      return this.containsType(this.form.contents, 'video')
    }
    return false
  }

  get presenceImage() {
    if (this.form.contents) {
      return this.containsType(this.form.contents, 'image')
    }
    return false
  }

  get presenceButton() {
    if (this.form.contents) {
      return this.containsType(this.form.contents, 'button')
    }
    return false
  }

  get requiredRule() {
    return {
      templateId: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.display_id'),
      }),
      templateName: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.flex_message_template.template_name'),
      }),
    }
  }

  editTemplate() {
    this.templateModalVisible = true
  }

  onCloseModal() {
    this.templateModalVisible = false
  }

  onCaptureMessage(file: File, url: string) {
    this.messageImg = file
    this.messageImgUrl = url
    this.isTemplateChanged = true
  }

  async doSave() {
    this.form.type = this.templateType
    this.form.is_video = this.presenceVideo
    this.form.is_image = this.presenceImage
    this.form.is_button = this.presenceButton
    if (this.form._id === '' || this.isMessageChanged || this.form.img === '' || this.isTemplateChanged) {
      try {
        if (this.messageImg) {
          const uploaded = await UploadApi.uploadFile(this.messageImg)
          if (uploaded && uploaded.file_url_org) {
            this.form.img = uploaded.file_url_org
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    let success
    if (this.form._id === '') {
      if (this.isSuper) {
        this.form.template_type = this.type
      } else {
        this.form.template_type = 'custom'
      }
      success = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.ADD, {
        ...this.form,
      })
    } else {
      success = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.UPDATE, {
        ...this.form,
      })
    }
    if (success) {
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
      this.$emit('updateTemplates')
    }
  }

  onSubmit() {
    try {
      this.$refs.formRef
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            return
          }
          this.loading = true
          await this.doSave()
          this.loading = false
          this.visible = false
        })
        .catch((error: unknown) => {
          console.log('error', error)
        })
    } catch (error) {
      console.log('error', error)
    }
  }

  containsType(obj, type) {
    if (typeof obj !== 'object' || obj === null) return false

    if (Array.isArray(obj)) {
      return obj.some((item) => this.containsType(item, type))
    }

    for (const key in obj) {
      if (key === 'type' && obj[key] === type) {
        return true
      }

      if (typeof obj[key] === 'object') {
        if (this.containsType(obj[key], type)) {
          return true
        }
      }
    }

    return false
  }

  @Watch('imgFile', { immediate: true })
  getMessageImg() {
    this.messageImg = this.imgFile
    this.messageImgUrl = this.previewImageUrl
  }

  created() {
    this.currentAltText = cloneDeep(this.altText)
    this.form = { ...this.form, ...cloneDeep(this.template) }
    this.parentForm = this.form as any
    this.initForm = cloneDeep(this.parentForm)
    this.$nextTick(() => {
      this.$refs.formRef.validate()
    })
  }
}
</script>

<style scoped lang="scss">
.flex-message-content {
  background-color: #7491bd;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
}
.horizontal-line-dashed {
  border-bottom: 1px dashed #9e9e9e;
}
:deep(.q-chip.btn-cancel),
:deep(.q-chip.btn-save-grey),
:deep(.q-chip.btn-save) {
  margin: 0;
}

:deep(.q-chip.btn-cancel .q-chip__content),
:deep(.q-chip.btn-save-grey .q-chip__content),
:deep(.q-chip.btn-save .q-chip__content) {
  justify-content: center;
}
</style>
